<template>
  <div>
    <header class="bar bar-nav">
      <h1 class='title'>评价中心</h1>
    </header>
    <div class="content">
      <div class="buttons-tab">
        <a id ="t1" href="#tab1" class="active tab-link button">待评价</a>
        <a id ="t2" href="#tab2" class="tab-link button">已评价</a>
      </div>
      <div class="content-block">
        <div class="tabs">
          <div id="tab1" class="tab active">
            <myCommentOrder :commentMerchandise="waitCommentMerchandise"
                            buttonName1="评价晒单"></myCommentOrder>
          </div>
          <div id="tab2" class="tab">
            <myCommentOrder :commentMerchandise="commentedMerchandise"
                            buttonName1="追加评价" buttonName2="查看评价" @response = 'getMerchandiseComments'></myCommentOrder>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import {mapState} from 'vuex'
  import myCommentOrder from '../comment/child/MyCommentOrder.vue'
  export default {
    data () {
      return {
        waitCommentMerchandise: this.$store.state.myOrder.waitCommentMerchandise,
        commentedMerchandise: this.$store.state.myOrder.commentedMerchandise
      }
    },
    components: {
      myCommentOrder
    },
    mounted () {
    },
    computed: {
      ...mapState([
        'myOrder'
      ])
    },
    methods: {
      goBack () {
        this.$router.go(-1)
      },
      getMerchandiseComments (merch) {
        var self = this
        this.gcapi('getMerchandiseComments', merch.merchandiseId).then((response) => {
          if (response.body.code === 1) {
            $.toast(response.body.message)
            return
          }
          $.hidePreloader()
          self.$router.push(
            {name: 'getComments', query: {BOrderComments: JSON.stringify(response.body.result), merch: JSON.stringify(merch)}})
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EvaluationOrder.vue?9c16059e